import Cookies from 'js-cookie'

/**
 * Every cookie this app writes is a portal credential, so both flags are unconditional.
 *
 * `secure` is accepted on http://localhost — browsers treat it as a trustworthy origin —
 * so this does not need an environment branch. `sameSite: 'strict'` is safe because the
 * only writer is the SPA itself, on its own origin, after the login redirect has already
 * landed; no cross-site navigation needs to carry these.
 */
export const setCookies = (name: string, value: string): void => {
  Cookies.set(name, value, {
    path: '/',
    sameSite: 'strict',
    // Local dev genuinely runs over plain http://localhost — `secure: true`
    // unconditionally would silently stop the cookie from being set at all
    // there, breaking login. Real HTTPS deployments still get the flag.
    secure: window.location.protocol === 'https:',
  })
}

export const getCookies = (name: string): string | undefined => {
  return Cookies.get(name)
}

export const removeCookies = (name: string): void => {
  Cookies.remove(name, {
    expires: 0,
    path: '/',
  })
}
